import React, {createContext, useEffect, useState, useMemo } from "react"
export const NotificationContext = createContext(null);

const NotificationComponent = ({ children }) => {

	let initialState = {
		action: "",
		data: {}
	}

	const [showHideNotification, setShowHideNotification] = useState("");
	const [notificationMarkup, setNotificationMarkup] = useState("");
	const [notificationState, setNotificationState] = useState(initialState);
	const value = useMemo(() => [notificationState, setNotificationState], [notificationState]);

	useEffect(() => {
		if(notificationState && notificationState.action === 'add'){			
			setShowHideNotification("show");
			setNotificationMarkup(notificationState.data.html)

			setTimeout(() => {
				setNotificationState({action: 'hide',data: {"html": ""}});
			}, 10000);
		}

		if(notificationState && notificationState.action === 'hide'){
			setShowHideNotification("hide")
			setNotificationMarkup("")
		}
		
	}, [notificationState])



  	return(
		<NotificationContext.Provider value={value}>
			<div className={`notification  ${showHideNotification}` }>{notificationMarkup}</div>
			{children}
		</NotificationContext.Provider>
  	)
}

// Wrapper component

const Notification = ({ children }) => {
  return(
      <NotificationComponent>
        {children}
      </NotificationComponent>
  )
}

export default Notification
